import _ from "lodash";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import Button from "UI/Button";
import Heading from "UI/Heading";

import Container from '../components/Container';
import ProjectCard from "../components/ProjectCard";
import CreateProjectDialog from "../components/CreateProjectDialog";
import ProjectCardSkeleton from "../components/Skeletons/ProjectCardSkeleton";
import Briefcase from "UI/Heroicons/Briefcase";
import BlankProjects from "Components/BlankStates/BlankProjects";
import Plus from "UI/Heroicons/Plus";

class ProjectsController extends React.Component
{
    state = {
        creatingProject: false
    };

    static propTypes = {
        loading: PropTypes.bool.isRequired,
        projects: PropTypes.array.isRequired,
    };

    render()
    {
        const actions = <Button type='primary' className='space-x-2' onClick={() => this.setState({ creatingProject: true})}>
            <Plus className='w-5' />
            <span>Create a new project</span>
        </Button>;

        const title = <div className='flex'>
            <Briefcase className='w-7 mr-3' />Projects
        </div>;

        return <Container>
            <Heading
                title={title}
                description='Get started by creating a project, this can be a goal you’re working towards or a particular area of support your charity provides.'
                actions={actions}
            />

            <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6'>
                {
                    this.props.loading ? <ProjectCardSkeleton /> : _.map(
                        this.props.projects,
                        project => <ProjectCard key={project.id} project={project} />
                    )
                }
            </div>

            {
                this.renderBlankState()
            }

            <CreateProjectDialog
                open={this.state.creatingProject}
                onClose={() => this.setState({creatingProject: false})}
            />
        </Container>;
    }

    renderBlankState()
    {
        if (this.props.loading) {
            return null;
        }

        if (this.props.projects.length > 0) {
            return null;
        }

        return <div className='relative'>
            <BlankProjects className='text-gray-600 absolute right-0 mr-16 -mt-12 w-52' />
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    accountId: state.currentAccountId,
    projects: _.filter(state.projects, project => project.account_id === state.currentAccountId),
});

export default connect(mapStateToProps)(ProjectsController);
